import { DownloadIcon } from 'lucide-react';
import { cn } from '@rocco/utils/cn';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@rocco/components/tooltip';

/**
 * Extra actions for a chat message attachment.
 */
export function ChatMessageAttachmentActions({
    className,
    url,
    filename,
}: {
    className?: string;
    url: string;
    filename: string;
}) {
    return (
        <div
            className={cn(
                'flex items-center rounded-[4px] bg-black/60 text-white/80 shadow-sm backdrop-blur-sm',
                className,
            )}
            onClick={(e) => e.stopPropagation()}
        >
            <AttachmentDownloadButton url={url} filename={filename} />
        </div>
    );
}

function AttachmentDownloadButton({
    url,
    filename,
}: {
    url: string;
    filename: string;
}) {
    return (
        <TooltipProvider delayDuration={0}>
            <Tooltip disableHoverableContent>
                <TooltipTrigger asChild>
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener"
                        download
                        aria-label={`Download ${filename}`}
                        className="grid size-[32px] place-items-center rounded-[4px] hover:bg-black hover:text-white"
                    >
                        <DownloadIcon className="size-[16px]" />
                    </a>
                </TooltipTrigger>
                <TooltipContent>Download</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
